<div class="loading-container lbg">
    <mat-spinner></mat-spinner>
</div>